// createInitialStore.js
'use strict';
import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import XssFilters from 'xss-filters';

import { redux as reduxDebug } from './resource/debug.js';
import reducer from './reducer/reducer.js';

const reduxLog = reduxDebug.extend('log');

// User will see NOTHING before this promise resolved.
const _createInitialStore = async ({
  query,
  extra: { headerCountry, language, ssrHeaderLanguage, initI18nLanguage },
}) => {
  const log = reduxLog.extend('_createInitialStore');
  log('init');

  const defaultState = createStore(reducer).getState();

  let region = null;
  if (Array.isArray(query.region)) {
    region = query.region[0];
  } else {
    region = query.region;
  }

  const preloadedState = {
    me: { country: headerCountry || defaultState.getIn(['me', 'country']) },
    operations: {
      config: {
        language,
        initI18nLanguage, // To monitor i18n parse header result
        ssrHeaderLanguage, // To monitor CDN/Nginx behavior
        currentConfigKey: region,
      },
    },
  };
  log('preloadedState', preloadedState);

  const store = createStore(
    reducer,
    defaultState.mergeDeep(preloadedState),
    applyMiddleware(thunk)
  );

  // only add modal on SSR, to prevent add modal on init store at client side.
  if ('tw' === headerCountry) {
    const addModal = (await import('./action/addModal.js')).default;
    store.dispatch(addModal({ id: 'LandingPageModal', isLowerThanAll: true }));
  }

  log('end');
  return { store };
};

const filterObject = (object = {}) => {
  return Object.keys(object).reduce((current, key) => {
    const assignObject = {};
    assignObject[key] = XssFilters.inHTMLData(object[key]);
    return Object.assign({}, current, assignObject);
  }, {});
};

export const createInitialStore = ({ params, query, cookies, extra } = {}) => {
  const safeParams = filterObject(params);
  const safeQuery = filterObject(query);
  const safeCookies = filterObject(cookies);
  const safeExtra = filterObject(extra);
  return _createInitialStore({
    params: safeParams,
    query: safeQuery,
    cookies: safeCookies,
    extra: safeExtra,
  });
};

export default createInitialStore;
